import { loadable } from '../../../common/utils/lazyLoading';
const SiteList = loadable(() => import('../SiteList'));
const UpdateSite = loadable(() => import('../UpdateSite'));
export default [
    {
        id: 'site-list',
        title: 'Site list',
        route: 'site-list',
        component: SiteList,
    },
    {
        id: 'update-site',
        title: 'Update Site',
        route: 'update-site',
        component: UpdateSite,
    },
];
